import { STICKER } from "../apiConstant";
import BaseApi from "../baseApi";

class StickerApi extends BaseApi {
    constructor() {
        super();
        this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
        this.$axiosInstance = this.initAxiosInstance();
    }

    uploadSticker(body) {
        return this.post(`${STICKER}/upload`, body);
    }

    deleteSticker(stickerId) {
        return this.post(`${STICKER}/delete/${stickerId}`);
    }

    getStickerByPackId(packId) {
        return this.post(`${STICKER}/get-sticker/${packId}`);
    }

    addKeyword(body) {
        return this.post(`${STICKER}/add-keyword`, body);
    }

    getStickerByKeyword(keyword) {
        return this.post(`${STICKER}/get-sticker/search`, {keyword: keyword});
    }
}
export default StickerApi;
